import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Pagina1 from '../testComponents/visualComponent';
import Pagina2 from '../testComponents/olfactoryComponent';
import Pagina3 from '../testComponents/tasteComponent';
import Pagina4 from '../testComponents/noteComponent';
import Pagina5 from '../testComponents/orderComponent';
import ayuda1 from '../images/ayuda/visual-vertical.jpg';
import ayuda2 from '../images/ayuda/olfativa-vertical.jpg';
import ayuda3 from '../images/ayuda/gustativa-vertical.jpg';

function TsIcon({ name }) {
    const props = { width: 22, height: 22, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" };
    switch (name) {
        case 'home':    return <svg {...props}><path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/><path d="M10 20v-6h4v6"/></svg>;
        case 'back':    return <svg {...props}><path d="M15 18l-6-6 6-6"/></svg>;
        case 'forward': return <svg {...props}><path d="M9 18l6-6-6-6"/></svg>;
        case 'list':    return <svg {...props}><line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/><line x1="8" y1="18" x2="21" y2="18"/><line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/><line x1="3" y1="18" x2="3.01" y2="18"/></svg>;
        case 'check':   return <svg {...props}><polyline points="20 6 9 17 4 12"/></svg>;
        case 'help':    return <svg {...props}><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>;
        default: return null;
    }
}

const helpUrls = [
    ayuda1,
    ayuda2,
    ayuda3,
    {
        A: `${process.env.REACT_APP_SRC_URL}/A.jpg`,
        B: `${process.env.REACT_APP_SRC_URL}/B.jpg`,
        C: `${process.env.REACT_APP_SRC_URL}/C.jpg`,
        D: `${process.env.REACT_APP_SRC_URL}/D.jpg`,
    },
    ''
];

const SliderComponent = () => {
    const { t, i18n } = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const [test, setTest] = useState(null);
    const [currentTest, setCurrentTest] = useState(null);
    const [isHelpPopupVisible, setHelpPopupVisible] = useState(false);
    const [hintsClicked, setHintsClicked] = useState(false);
    const [isSubmitPopupVisible, setSubmitPopupVisible] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [canGoNext, setCanGoNext] = useState(false);
    const navigate = useNavigate();
    const saveAnswersRef = useRef(null);

    useEffect(() => {
        const currentTest = JSON.parse(localStorage.getItem('currentTest'));
        if (currentTest) { fetchTestDetails(currentTest.id); }
    }, []);

    // Reset next-button state whenever the page changes
    // Pages 3 (taste) and 5 (order) are always completable — don't reset them
    useEffect(() => {
        if (currentPage !== 3 && currentPage !== 5) setCanGoNext(false);
    }, [currentPage]);

    const fetchTestDetails = (testId) => {
        const xhr = new XMLHttpRequest();
        const url = `${process.env.REACT_APP_API_URL}/getTest/${testId}`;
        xhr.open("GET", url, true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4 && xhr.status === 200) {
                const data = JSON.parse(xhr.responseText);
                setTest(data.object);
                setCurrentTest(data.title);
            }
        };
        xhr.send();
    };

    const handleShowInstructions = () => {
        const instructionsDiv = document.getElementById('instructions-div');
        if (instructionsDiv) { instructionsDiv.style.display = 'block'; }
    };

    const handleHelpClick = () => {
        let imageUrl;
        if (currentPage === 4 && currentTest) {
            const suffix = i18n.language === 'en' ? '_en' : '';
            imageUrl = `${process.env.REACT_APP_SRC_URL}/${currentTest}${suffix}.jpg`;
        } else {
            imageUrl = helpUrls[currentPage - 1];
        }
        if (imageUrl) {
            setPopupImage(imageUrl);
            setHelpPopupVisible(true);
        }
    };

    useEffect(() => {
        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (isIOS) { document.body.classList.add("safari"); }
        return () => { if (isIOS) { document.body.classList.remove("safari"); } };
    }, []);

    const handleSaveAnswers = () => {
        if (saveAnswersRef.current) { saveAnswersRef.current(); }
    };

    const renderContent = () => {
        if (!test) { return <div>{t('common.loading')}</div>; }
        switch (currentPage) {
            case 1: return <Pagina1 first={test[0]} second={test[1]} actual={currentTest.title} setCanGoNext={setCanGoNext} />;
            case 2: return <Pagina2 first={test[2]} second={test[3]} third={test[4]} fourth={test[5]} actual={currentTest.title} setCanGoNext={setCanGoNext} />;
            case 3: return <Pagina3 actual={currentTest.title} setCanGoNext={setCanGoNext} />;
            case 4: return <Pagina4 actual={currentTest.title} first={test[11]} second={test[12]} onSaveAnswers={(saveAnswers) => saveAnswersRef.current = saveAnswers} setCanGoNext={setCanGoNext} />;
            case 5: return <Pagina5 setCanGoNext={setCanGoNext} />;
            default: return null;
        }
    };

    const clearStorageAndRedirect = () => {
        ['currentTest','selected0','selected1','selected2','selected3','selected4','selected5','selected6']
            .forEach(key => localStorage.removeItem(key));
        navigate('/choose-wine');
    };

    return (
        <div className="test-container">
            <div className="slider-container my-3">
                <button className="stats-close" onClick={clearStorageAndRedirect} aria-label={t('common.close')}>×</button>
                {renderContent()}
            </div>

            <nav className="ts-bottom-nav">
                {/* Inicio */}
                <Link to="/" className="ts-nav-btn" aria-label={t('common.home')}>
                    <TsIcon name="home" />
                    <span>{t('common.home')}</span>
                </Link>

                {/* Anterior */}
                <button
                    className="ts-nav-btn ts-nav-prev"
                    onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
                    aria-label={t('common.previous')}
                >
                    <TsIcon name="back" />
                    <span>{t('common.previous')}</span>
                </button>

                {/* Instrucciones */}
                <button
                    className="ts-nav-btn ts-nav-inst"
                    onClick={handleShowInstructions}
                    aria-label={t('common.instructions')}
                >
                    <TsIcon name="list" />
                    <span>{t('common.instructions')}</span>
                </button>

                {/* Siguiente / Enviar */}
                {currentPage === 4 ? (
                    <button
                        className="ts-nav-btn ts-nav-next btn-next"
                        onClick={() => setSubmitPopupVisible(true)}
                        disabled={!canGoNext}
                        aria-label={t('common.send')}
                    >
                        <TsIcon name="check" />
                        <span>{t('common.send')}</span>
                    </button>
                ) : (
                    <button
                        className="ts-nav-btn ts-nav-next btn-next"
                        onClick={() => setCurrentPage(p => p + 1)}
                        disabled={!canGoNext}
                        aria-label={t('common.next')}
                    >
                        <TsIcon name="forward" />
                        <span>{t('common.next')}</span>
                    </button>
                )}

                {/* Pistas */}
                <button
                    className={`ts-nav-btn${hintsClicked ? '' : ' ts-nav-hints'}`}
                    onClick={() => { setHintsClicked(true); handleHelpClick(); }}
                    aria-label={t('common.hints')}
                >
                    <TsIcon name="help" />
                    <span>{t('common.hints')}</span>
                </button>
            </nav>

            {isHelpPopupVisible && popupImage && (
                <Popup imageUrl={popupImage} onClose={() => { setHelpPopupVisible(false); setPopupImage(null); }} isHelpPopup={true} />
            )}
            {isSubmitPopupVisible && (
                <Popup
                    text={t('test.confirm_submit')}
                    onClose={() => setSubmitPopupVisible(false)}
                    onConfirm={handleSaveAnswers}
                    isHelpPopup={false}
                />
            )}
        </div>
    );
};

const Popup = ({ text, onClose, onConfirm, imageUrl, isHelpPopup }) => {
    const { t } = useTranslation();
    return (
        <div className="custom-overlay" onClick={!imageUrl ? onClose : undefined}>
            <div className={`custom-popup${isHelpPopup ? ' custom-popup--help' : ''}`} onClick={e => e.stopPropagation()}>
                <button className="custom-popup-close" onClick={onClose} aria-label={t('common.close')}>×</button>
                {text && <p className="custom-popup-text">{text}</p>}
                {imageUrl && (
                    <div className="custom-popup-images">
                        <img src={imageUrl} alt={t('common.help')} />
                    </div>
                )}
                {onConfirm && (
                    <div className="custom-popup-actions">
                        <button className="custom-popup-cancel" onClick={onClose}>{t('common.close')}</button>
                        <button className="custom-popup-confirm" onClick={onConfirm}>{t('common.send')}</button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SliderComponent;
